import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { CrudBrandService } from "app/_services/MasterCrudOps/crud-brand.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
declare const swal: any;

@Component({
  selector: "app-add-brand",
  templateUrl: "./add-brand.component.html",
  styleUrls: ["./add-brand.component.css"],
})
export class AddBrandComponent implements OnInit {
  addBrandForm: UntypedFormGroup;
  pageNumber: number;
  pageSize: number;

  constructor(
    private readonly crudBrandService: CrudBrandService,
    private readonly dialogRef: MatDialogRef<AddBrandComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
    this.initilizeForm();
  }

  ngOnInit() {
    this.initilizeForm();
  }

  initilizeForm() {
    this.addBrandForm = this.formBuilder.group({
      brandName: [null, [Validators.required, Validators.maxLength(50)]],
      description: [null, [Validators.required, Validators.maxLength(100)]],
    });
  }

  saveBrand() {
    let errorMessage = "";
    const brandName = (this.addBrandForm.value.brandName ?? "").trim();
    const description = (this.addBrandForm.value.description ?? "").trim();

    if (brandName.length > 50) {
      errorMessage = "Brand name cannot be more than 50 characters.";
    }
    if (description.length > 100) {
      errorMessage += "\nDescription cannot be more than 100 characters.";
    }

    if (errorMessage.length > 0) {
      swal({
        title: "",
        text: errorMessage,
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
    } else {
      let model = { brandName: brandName, description: description };
      this.crudBrandService.saveBrand(model).subscribe(
        (data) => {
          if (data.didError) {
            swal({
              title: "",
              text: data.message,
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          } else {
            swal({
              title: "",
              text: data.message,
              type: "success",
              confirmButtonClass: "btn btn-info",
            });
          }
          let result = {
            status: true,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          };
          this.dialogRef.close(result);
        },
        (error) => {
          let errorMessage =
            error.error?.title ??
            error.error ??
            "Something went wrong. Please contact admin.";

          // Check if it's a validation error response with the `errors` object
          if (error.error?.errors) {
            const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
            if (allErrors.length > 0) {
              errorMessage = allErrors[0]; // Use the first validation message
            }
          } else if (typeof error.error === "string") {
            errorMessage = error.error;
          } else if (error.error?.title) {
            errorMessage = error.error.title;
          }
          swal({
            title: "",
            text: errorMessage,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      );
    }
  }

  close() {
    let result = {
      status: false,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    };
    this.dialogRef.close(result);
  }
}
